import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';

const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { darkTheme } = useSelector((state: RootState) => state.user.settings);

  useEffect(() => {
    const htmlElement = document.documentElement;

    if (darkTheme) {
      htmlElement.classList.add('dark');
    } else {
      htmlElement.classList.remove('dark');
    }
  }, [darkTheme]);

  return <>{children}</>;
};

export default ThemeProvider;
